<template>
  <section>
    <city-template-list :query="query" />
  </section>
</template>

<script>
import CityTemplateList from '@/components/mis/CityTemplateList'

export default {
  name: 'CityTemplates',
  components: {
    CityTemplateList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
